import React, { useEffect, useState } from 'react';
import { Button } from 'reactstrap';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Modal from '../../../common/modal/Modal';
import {
  getInternalParcel,
  putInternalParcelUpdateItems,
} from '../../../../actions';
import EditInternalCargoItemForm from './EditInternalCargoItemForm';

const EditInternalCargoItemButton = ({
  internalParcel,
  dispatchPutInternalParcelUpdateItems,
  dispatchGetInternalParcel,
}) => {
  const [showModal, setShowModal] = useState(false);
  const [modalBody, setModalBody] = useState('');

  const onModalSubmit = async (formvalues) => {
    const mappedItems = formvalues.internalCargoItems.map((item) => ({
      ...item,
      cargoCategoryId: item.cargoCategoryId.value || item.cargoCategoryId,
    }));

    const updateItems = await dispatchPutInternalParcelUpdateItems({
      internalParcelId: internalParcel.id,
      internalCargoItems: mappedItems,
    });

    if (updateItems) {
      dispatchGetInternalParcel({ id: internalParcel.id });
      setModalBody(null);
      setShowModal(false);
    }
  };

  const openModal = async () => {
    setShowModal(true);
  };

  const closeModal = () => setShowModal(false);

  const generateInitialValues = ({ internalCargoItemList }) => {
    const grouped = internalCargoItemList.reduce((acc, item) => {
      const key = item.ticketIdentificationId;

      if (!acc[key]) {
        acc[key] = {
          ticketIdentificationId: key,
          quantity: item.quantity || 0,
          cargoCategoryId: {
            value: item.cargoCategoryId,
            label: item.cargoCategoryName,
          },
          description: item.description,
          weight: item.weight,
        };
      } else {
        acc[key].quantity += item.quantity || 0;
      }

      return acc;
    }, {});

    const internalCargoItems = Object.values(grouped);

    return {
      internalCargoItems,
    };
  };

  const buildModalBody = () => {
    const newModalBody = (
      <EditInternalCargoItemForm
        onCancel={closeModal}
        onSubmit={onModalSubmit}
        initialValues={generateInitialValues(internalParcel)}
      />
    );
    setModalBody(newModalBody);
  };

  useEffect(() => {
    if (showModal !== false) {
      buildModalBody();
    }
  }, [showModal]);

  return (
    <>
      <Modal
        show={showModal}
        title="Modificar Datos de Paquetes"
        body={modalBody}
        size="xl"
        onClickCancel={closeModal}
        onClickClose={closeModal}
      />
      <Button color="info" onClick={openModal}>
        <i className="fa fa-pencil" /> Modificar Datos
      </Button>
    </>
  );
};

EditInternalCargoItemButton.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  internalParcel: PropTypes.object.isRequired,
  dispatchPutInternalParcelUpdateItems: PropTypes.func.isRequired,
  dispatchGetInternalParcel: PropTypes.func.isRequired,
};

const mapDispatchToProps = {
  dispatchPutInternalParcelUpdateItems: putInternalParcelUpdateItems,
  dispatchGetInternalParcel: getInternalParcel,
};

export default connect(null, mapDispatchToProps)(EditInternalCargoItemButton);
